import React, { FC } from 'react';
import { Form } from 'react-bootstrap';
import { Button, ValidationForm } from '../../atoms';
import cn from 'classnames';
import styles from './LandscapeAboutLandscapeOrganism.module.css';
import { EntityGalleryTileResponseDto } from '../../../store/landscapeAPI/galleryTile/dto/response/entity-gallery-tile-response.dto';
import { ImageUploader } from '../../molecules';
import { ImageMeta } from '../../../store/mediaAPI/media/dto/request/media-save-request';

interface LandscapeAboutLandscapeOrganismProps {
  handleOnChange: (galleryTile: EntityGalleryTileResponseDto) => void;
  galleryTile: EntityGalleryTileResponseDto;
  callbackFn: (galleryTile: EntityGalleryTileResponseDto) => void;
  handleImageOnChange: (imageMeta: ImageMeta) => void;
  handleCancel: () => void;
}

const LandscapeAboutLandscapeOrganism: FC<
  LandscapeAboutLandscapeOrganismProps
> = ({
  handleOnChange,
  galleryTile,
  callbackFn,
  handleImageOnChange,
  handleCancel,
}) => {
  return (
    <div className={cn(styles.landscapeWrapper)}>
      <ValidationForm onSubmitCallback={() => callbackFn(galleryTile)}>
        <Form.Label>Media</Form.Label>
        <hr />
        <Form.Group className="mb-3">
          <ImageUploader
            id={galleryTile.id}
            setImage={(e) => handleOnChange({ ...galleryTile, blobUrl: e })}
            setImageMeta={(imageMeta) => handleImageOnChange(imageMeta)}
            imageSrc={galleryTile.blobUrl ?? undefined}
          />
        </Form.Group>
        <div className={cn(styles.inputFieldsWrapper)}>
          <Form.Group className="mb-3">
            <Form.Label>Title</Form.Label>
            <Form.Control
              required
              type="text"
              placeholder="Enter title"
              onChange={(e) =>
                handleOnChange({ ...galleryTile, blobTitle: e.target.value })
              }
              value={galleryTile.blobTitle}
            />
            <Form.Control.Feedback type="invalid">
              Please provide a valid title
            </Form.Control.Feedback>
          </Form.Group>
          <Form.Group className="mb-3">
            <Form.Label>Description</Form.Label>
            <Form.Control
              type="text"
              placeholder="Enter description"
              onChange={(e) =>
                handleOnChange({
                  ...galleryTile,
                  blobDescription: e.target.value,
                })
              }
              value={galleryTile.blobDescription}
            />
          </Form.Group>
          <div className={cn(styles.buttonsWrapper)}>
            <div className={cn(styles.button)}>
              <Button variant="dark" type="submit">
                Save
              </Button>
            </div>
            <div className={cn(styles.button)}>
              <Button onClick={handleCancel} variant="light">
                Cancel
              </Button>
            </div>
          </div>
        </div>
      </ValidationForm>
    </div>
  );
};

export default LandscapeAboutLandscapeOrganism;
